import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    ILoadMergeTestResultsAction,
    ILoadMergeTestResultsSuccessAction,
    ILoadMergeTestResultsErrorAction
} from '../actions/service/merge/load-merge-test-results';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';

export type MergeTestResultsAction
    = ILoadMergeTestResultsAction
    | ILoadMergeTestResultsSuccessAction
    | ILoadMergeTestResultsErrorAction;

const init = (state: ITicketsState, action: MergeTestResultsAction) => ({
    ...state,
    mergeTestResultsRequest: {
        ...initialState.mergeTestResultsRequest,
        status: action.status,
    }
});

const success = (state: ITicketsState, action: MergeTestResultsAction) => ({
    ...state,
    mergeTestResultsRequest: {
        ...initialState.mergeTestResultsRequest,
        status: action.status,
        mergeTestResults: (action as ILoadMergeTestResultsSuccessAction).mergeTestResults
    }
});

const failure = (state: ITicketsState, action: MergeTestResultsAction) => ({
    ...state,
    mergeTestResultsRequest: {
        ...initialState.mergeTestResultsRequest,
        status: action.status,
        error: (action as ILoadMergeTestResultsErrorAction).error
    }
});

export const mergeTestResultsReducer = createAsyncReducer(initialState, init, success, failure);
